<template>
  <div class="wrapper">
    <div class="contactme">
      <div class="contact-info">
        <h2 class="social">Check my social media</h2>
        <div class="contact-buttons">
          <a href="https://github.com/BorjaZarco">
            <div class="contact-button github">
              <span>GitHub</span>
              <i class="fab fa-github fa-lg"></i>
            </div>
          </a>
          <a href="https://www.linkedin.com/in/borja-zarco-cerezo">
            <div class="contact-button linkedin">
              <span>LinkedIn</span> 
              <i class="fab fa-linkedin fa-lg"></i>
            </div>
          </a>
          <a href="https://twitter.com/borgmenz">
            <div class="contact-button twitter">
              <span>Twitter</span> 
              <i class="fab fa-twitter fa-lg"></i>
            </div>  
          </a>
        </div>
      </div>

      <form method="POST" action="https://formspree.io/borjiasecundario@gmail.com" class="email">
        <div class="email-title">
          <h2>Send me an email</h2>
        </div>
        <label for="pwd">From</label>
        <input type="text" @keypress="checkMail()" name="email" v-model="email" placeholder="Introduce your E-Mail" class="email-input user">
        <label for="pwd">Subject</label>
        <input type="text" @keypress="checkMail()" name="_subject" v-model="subject" class="email-input">
        <label for="pwd">Message</label>
        <textarea type="message" @keypress="checkMail()" name="message" v-model="message" class="email-input message"></textarea>
        <div class="button-wrapper">
          <button type="submit" class="send-button" :disabled="notValidMail">Send</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { post } from "axios";

export default {
  name: "ContactMe",
  data () {
    return {
      email: "",
      subject: "",
      message: "",
      notValidMail: true
    }
  },
  methods: {
    checkMail: function () {
      console.log (this.notValidMail)
      if (!this.email) { 
        return this.notValidMail = true
      }
      if (!this.subject) {
        return this.notValidMail = true 
      }
      if (!this.message) {        
        return this.notValidMail = true 
      }
      return this.notValidMail = false;
    }
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
}

label {
  margin-bottom: 5px;
}

.wrapper {
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contactme {
  display: grid;
  padding: 20px;
  column-gap: 20px;
  column-rule-style: solid;
  column-rule-color: black;
  grid-template-columns: 1fr 1fr;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

}

.contact-buttons {
  grid-column: 1/2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
}

.contact-button {
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: center;
  height: 50px;
  width: 150px;
  border-radius: 50px;
  margin-top: 20px;
  color: #ffffff;
  border: solid 2px;
  transition-duration: 0.5s;
}

.contact-button div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.github {
  background-color: black;
  border-color: black; 
  color: #ffffff;
}

.twitter {
  background-color:#00aced;
  border-color: #00aced; 
  color: #ffffff;
}

.linkedin {
  background-color: #0077B5;
  border-color: #0077B5; 
  color: #ffffff;
}

.github:hover {
  color: black;
  background-color: #fff;
  transition-duration: 0.5s;
}

.twitter:hover {
  color:#00aced;
  background-color: #fff;
  transition-duration: 0.5s;
}

.linkedin:hover {
  color: #0077B5;
  background-color: #fff;
  transition-duration: 0.5s;
}

.email {
  text-align: left;
  grid-column: 2/2;
  display: flex;
  padding-left: 40px; 
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  border-left: solid 1px gray;
}

.email-input {
  font-family: 'Ubuntu';
  margin-bottom: 15px;
  border-radius: 4px;
  border: 1px solid #ccc;
  padding: 5px;
  width: 250px;
}

.message {
  height: 100px;
  
}

.button-wrapper {
  display: flex;
  justify-content: flex-end;
}

.send-button {
  font-family: 'Ubuntu';
  background-color: #1a73e8;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: #ffffff;
  height: 30px;
  width: 100px;
  margin-left: 160px; 
}

.send-button:disabled {
  cursor: no-drop;
  background-color: white;
  color: #ccc;
  border: solid 1px #ccc;

}

@media screen and (max-width:640px) {
    .contactme {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      box-shadow: none;
    }
    .contact-buttons {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    .contact-button {
      height: 50px;
      width: 50px;
      margin-left: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    span, .social {
      display: none;
    }

    .email {
      border: none;
      display: flex;
      padding: 0;
      text-align: center;
    }

    .email-title {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/ContactMe.vue